var debug = true;
window['raceTimer'] = null;
var RACE_STATUS = null;
var videoUrl = 'https://s3-eu-west-1.amazonaws.com/elbetvideo/';
var oldTicket = null;
var iosVersion = iOSversion();
var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
var checkIos = iOS ? iosVersion[0] : 10;
let language = lang === null ? 'en' : lang;
window['language'] = language;
//var token = location.search.split('token=')[1];

import Api from './api/api';
import Auth from './auth/auth';
import User from './user/user';
import LoginModalHelper from './helpers/login-modal-helper';
import Credit from './credit/credit';
import CookieHelper from './helpers/cookie-helper';
import NavbarDisplay from './navbar/navbar-display';
import JackpotWinnerNotice from './helpers/jackpot-winner-notice';
import {renderMenu} from './menu';
import {chat} from '../../lucky-balls/js/chat';

var SPECIAL_API_URL = 'https://api.elbet.us/index.php';
var SPECIAL_API_URL_DOMAINS = ['online.try.everymatrix.elbet.us'];

if (SPECIAL_API_URL_DOMAINS.indexOf(window.location.hostname) >= 0) {
  window['API_URL'] = SPECIAL_API_URL;
  console.log('Special API URL for domain ' + window.location.hostname + ' : ' + SPECIAL_API_URL);
} else {
  window['API_URL'] = API_URL;
}

let api = new Api(window['API_URL'] + '/dog-race');
let user = new User();
let auth = new Auth(api);
let credit = new Credit(api);
let navbar = new NavbarDisplay();

var ticket = {
    winner : {
        gameId : '01',
        gameBet : 0
    } , 
    place : {
        gameId : '05',
        gameBet : 0
    }, 
    show : {
        gameId : '06',
        gameBet : 0
    }, 
    trifecta : {
        gameId : '19',
        gameBet : 0,
        gamePretty : ''
    }, 
    perfecta : {
        gameId : '04',
        gameBet : 0
    }, 
    double_chance : {
        gameId : '07',
        gameBet : 0
    }, 
    low_high : {
        gameId : '14',
        gameBet : 0
    },
    odd_even : {
        gameId : '15',
        gameBet : 0
    }, 
    sum123 : {
        gameId : '17',
        gameBet : 0
    }, 
    sum12 : {
        gameId : '16',
        gameBet : 0
    }
};

var trifecta = {
    first : 0,
    second : 0,
    third : 0
};

var odds = [
'WinOdd1', 'WinOdd2', 'WinOdd3', 'WinOdd4', 'WinOdd5', 'WinOdd6',
'InFirstTwoOdd1', 'InFirstTwoOdd2', 'InFirstTwoOdd3', 'InFirstTwoOdd4', 'InFirstTwoOdd5', 'InFirstTwoOdd6',
'InFirstThreeOdd1', 'InFirstThreeOdd2', 'InFirstThreeOdd3', 'InFirstThreeOdd4', 'InFirstThreeOdd5', 'InFirstThreeOdd6',
'Win456Odd', 'Win123Odd',
'WinOddOdd', 'WinEvenOdd',
'FirstTwoLess75Odd', 'FirstTwoMore75Odd',
'FirstThreeLess105Odd', 'FirstThreeMore105Odd',
'FSOdd1_2', 'FSOdd1_3', 'FSOdd1_4', 'FSOdd1_5', 'FSOdd1_6',
'FSOdd2_1', 'FSOdd2_3', 'FSOdd2_4', 'FSOdd2_5', 'FSOdd2_6',
'FSOdd3_1', 'FSOdd3_2', 'FSOdd3_4', 'FSOdd3_5', 'FSOdd3_6',
'FSOdd4_1', 'FSOdd4_2', 'FSOdd4_3', 'FSOdd4_5', 'FSOdd4_6',
'FSOdd5_1', 'FSOdd5_2', 'FSOdd5_3', 'FSOdd5_4', 'FSOdd5_6',
'FSOdd6_1', 'FSOdd6_2', 'FSOdd6_3', 'FSOdd6_4', 'FSOdd6_5',
'DC21Odd', 'DC31Odd', 'DC32Odd', 'DC41Odd', 'DC42Odd', 'DC43Odd', 'DC51Odd', 'DC52Odd', 'DC53Odd', 'DC54Odd', 'DC61Odd', 'DC62Odd', 'DC63Odd', 'DC64Odd', 'DC65Odd'
];

var dogClass = {
    1 : 'red-dog',
    2 : 'blue-dog',
    3 : 'grey-dog',
    4 : 'black-dog',
    5 : 'yellow-dog',
    6 : 'black-white-dog'
};

window.addEventListener('get_tickets_no_stats', function () {
    getTickets();
});

window.addEventListener('get_tickets', function () {
    getStatistics(api);
    getTickets();
});

// register login event listener
window.addEventListener('logout', function () {
    auth.logout();
});

window.addEventListener('get_credit', function () {
    credit.getCredit(user);
});

window.addEventListener('payout', function () {
    credit.requestPayout(user);
});

function loginManagement(auth, user, navbar, credit)  {

    if (user.isLogggedIn()) {
      window['token'] = CookieHelper.get('token');
      // make fake response object
      let response = {
        Data: {
          AuthUserResponse: [
            {
              Credit: credit.getCredit(user),
              Currency: CookieHelper.get('currency')
            }
          ]
        }
      };

      navbar.showLogedIn(user, response);

    } else {
      navbar.showLogedOut();
    }

    $('.logout-button').click(() => {
      var logoutEvent = new CustomEvent("logout");
      window.dispatchEvent(logoutEvent);
    });

    $('.login-button').click(() => {
      $('.login-modal').modal('show');
    });

    $('.login-user-button').click(() => {
      auth.login(LoginModalHelper.bind(user));
    });

    $('.user-username').on('keydown', function(e) {
      if (e.which == 13) {
        auth.login(LoginModalHelper.bind(user));
      }
    });

    $('.user-password').on('keydown', function(e) {
      if (e.which == 13) {
        auth.login(LoginModalHelper.bind(user));
      }
    });

    $('.login-modal').on('hidden.bs.modal', function () {
      LoginModalHelper.clearloginInputs();
    });

    $('.payout-pin-button').click(() => {
        var payoutEvent = new CustomEvent("payout");
        window.dispatchEvent(payoutEvent);
    });
  }

$(document).ready(function () {

    init(odds);
    getTickets();

    $('.select-bet').click(function(){
        var bet = $(this).data('bet');
        if(bet !== 'trifecta'){
            ticket[bet].gameBet = $(this).data('value');
            $('*[data-bet="'+bet+'"]').removeClass('betting-dogs-btn-red');
            $(this).addClass('betting-dogs-btn-red');
        } else {

            if($(this).hasClass('betting-dogs-btn-grey'))
                return false;

            var trifectaPlace = $(this).data('place');
            var trifectaNumber = $(this).data('number');
            var _this = $(this);
            handleTrifectaBet(_this, bet, trifectaPlace, trifectaNumber);
        }
    });

    window['buyFromTerminal'] = function() {
        var totalBets = 0;
        var prepareTicket = "|";
        var bettingAmount = parseFloat($('#betting-amount').val());

        if (!validateTrifectaBeforeBuy()) {
            $('#modal-title').text(langArr[language].trifecta_select_all || 'Please select all three trifecta positions');
            $('#gameModal').modal('show');
            return false;
        }

        for(var key in ticket) {
            if (ticket.hasOwnProperty(key)) {
                if(ticket[key].gameBet != 0){
                    totalBets++;
                    prepareTicket += ticket[key].gameId + pad(ticket[key].gameBet, 3)+'|'
                }
            }
        }

        if(typeof window.token == 'undefined' || window.token == 'null' || window.token == null || window.token == '' || window.token == 0  || window.token == 'NULL'){
            $('#modal-title').text(langArr[language].please_login);
            $('#gameModal').modal('show');
            return false;
        }

        if(totalBets == 0){
            //alert('Please select at least one combination.');
            $('#modal-title').text(langArr[language].chose_some_bets);
            $('#gameModal').modal('show');
            return false;
        }
        if(isNaN(bettingAmount) || bettingAmount == 0){
            //alert('Please select valid betting amount.');
            $('#modal-title').text(langArr[language].chose_valid_amount);
            $('#gameModal').modal('show');
            return false;
        }

        if (parseFloat(bettingAmount) < parseFloat($('#Dog6_MinBet').data('value'))) {
            $('#modal-title').text(langArr[language].minimum_stake_is + " " + $('#Dog6_MinBet').data('value'));
            $('#gameModal').modal('show');
            return false;
        }

        if (parseFloat(bettingAmount) > parseFloat($('#Dog6_MaxBet').data('value'))) {
            $('#modal-title').text(langArr[language].maximum_stake_is + " " + $('#Dog6_MaxBet').data('value'));
            $('#gameModal').modal('show');
            return false;
        }
        if (CookieHelper.get('uName') !== undefined && CookieHelper.get('uName') != '' && CookieHelper.get('uName') != null) {
            credit.getAsyncCredit(user).then(function(deposit)  {
                if (parseFloat(bettingAmount) > parseFloat(deposit)) {
                    $('#modal-title').text(langArr[language].you_dont_have_enough_deposit);
                    $('#gameModal').modal('show');
                    return false;
                }
                buyTicket(prepareTicket, bettingAmount);
                oldTicket = ticket;
                var oldBettingAmount = bettingAmount;
                resetTicket();
            }); 
        } else {
            buyTicket(prepareTicket, bettingAmount);
            oldTicket = ticket;
            var oldBettingAmount = bettingAmount;
            resetTicket();
        }
    };

    /**
    * Window token promise.
    */
    const getTokenPromise = () => {
     let tokenPromise = new Promise((resolve, reject) => {
       window.addEventListener("message", (event) => {
         try {
           if (JSON.parse(event.data).payload.action == 'login') {
             window['customLoggedIn'] = true;
             if (!JSON.parse(event.data).payload.token) {
               reject(new Error('Empty Token Recieved'))
             }
             window['customToken'] = JSON.parse(event.data).payload.token;
             resolve(window['customToken']);
           }
         } catch (error) {
           reject(error);
         }
     }, false);
        window['customToken'] ? resolve(window['customToken']) : '';
     });

     return tokenPromise;
   }

    /**
     * Pre Buy Logic.
     */
    const buyTicketAdapter = () => {

        var totalBets = 0;
        var prepareTicket = "|";
        var bettingAmount = parseFloat($('#betting-amount').val());

        if (!validateTrifectaBeforeBuy()) {
            $('#modal-title').text(langArr[language].trifecta_select_all || 'Please select all three trifecta positions');
            $('#gameModal').modal('show');
            return false;
        }

        for(var key in ticket) {
            if (ticket.hasOwnProperty(key)) {
                if(ticket[key].gameBet != 0){
                    totalBets++;
                    prepareTicket += ticket[key].gameId + pad(ticket[key].gameBet, 3)+'|'
                }
            }
        }

        if(totalBets == 0){
            //alert('Please select at least one combination.');
            $('#modal-title').text(langArr[language].chose_some_bets);
            $('#gameModal').modal('show');
            return false;
        }
        if(isNaN(bettingAmount) || bettingAmount == 0){
            //alert('Please select valid betting amount.');
            $('#modal-title').text(langArr[language].chose_valid_amount);
            $('#gameModal').modal('show');
            return false;
        }
        
        if (parseFloat(bettingAmount) < parseFloat($('#Dog6_MinBet').data('value'))) {
            $('#modal-title').text(langArr[language].minimum_stake_is + " " + $('#Dog6_MinBet').data('value'));
            $('#gameModal').modal('show');
            return false;
        }

        if (parseFloat(bettingAmount) > parseFloat($('#Dog6_MaxBet').data('value'))) {
            $('#modal-title').text(langArr[language].maximum_stake_is + " " + $('#Dog6_MaxBet').data('value'));
            $('#gameModal').modal('show');
            return false;
        }
        if (CookieHelper.get('uName') !== undefined && CookieHelper.get('uName') != '' && CookieHelper.get('uName') != null) {
            credit.getAsyncCredit(user).then(function(deposit)  {
                if (parseFloat(bettingAmount) > parseFloat(deposit)) {
                    $('#modal-title').text(langArr[language].you_dont_have_enough_deposit);
                    $('#gameModal').modal('show');
                    return false;
                }
                buyTicket(prepareTicket, bettingAmount);
                oldTicket = ticket;
                var oldBettingAmount = bettingAmount;
                resetTicket();
            }); 
        } else {
            buyTicket(prepareTicket, bettingAmount);
            oldTicket = ticket;
            var oldBettingAmount = bettingAmount;
            resetTicket();
        }
    }

    /**
     * Test is JSON string.
     * 
     * @param {string} str
     */
    const isJsonString = (str) => {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

     /**
     * On custom logout message from parent iframe
     */
    window.addEventListener("message", (event) => {
        try {
          if (!isJsonString(event)) {
            if (JSON.parse(event.data).payload.action == 'customLogout') {
              window['customLoggedIn'] = true;
              window['customToken'] = '';
            } 
          }
        } catch (error) {
          console.log(error);
        }
    }, false);

    /**
     * User Authetication.
     */
    const authenticate = async () => {
        if(!window['token']) {
            // if loginpopup=0 in url
             if (/loginpopup=0/.test(window['location']['href'])) {
                if (window['customLoggedIn'] && window['customToken']) {
                  buyTicketAdapter();
                } else {
                  // If no login token set, send login required msg to parent iframe
                  window['parent'].postMessage(JSON.stringify({
                    source:"elbet-messages",
                    payload:{action:"loginRequired"}
                  }),'*');
                  try {
                    await getTokenPromise();
                  } catch (error) {
                    // Game specific logic for clearing bets
                    resetTicket();
                    return;
                  }
                  buyTicketAdapter();
                }
             } else {
                $('#modal-title').text(langArr[language].please_login);
                $('#gameModal').modal('show');

                return;
            }
          } else {
            // If there is a url token ie window['token']
            if (/loginpopup=0/.test(window['location']['href'])) {
              // if customLogged in true and no customToken then request login 
              // (which means that login was initiated before but token has been removed)
              if (window['customLoggedIn'] && !window['customToken']) {
                  window['parent'].postMessage(JSON.stringify({
                  source:"elbet-messages",
                  payload:{action:"loginRequired"}
                }),'*');
                try {
                  await getTokenPromise();
                } catch (error) {
                    // Game specific logic for clearing bets
                    resetTicket();
                    return;
                }
                buyTicketAdapter();
              } else {
                buyTicketAdapter();
              } 
            } else {
                buyTicketAdapter();
            }
        }
    }

    $('#buyTicket').on('click', function(e) {
        e.stopImmediatePropagation();
        authenticate();
    });

    $('#delete-bets').click(function(){
        resetTicket();
    });
   
    $('.set-bet').click(function(){
        $('#betting-amount').val($(this).data('value'))
    });


    $('#gameModal').on('hidden.bs.modal', function () {
        $('#modal-title').text('');
    });

    $('#repeatTicket').click(function(){
        var n =0;
        for(var key in oldTicket) {
            if (oldTicket.hasOwnProperty(key)) {
                if(oldTicket[key].gameBet != 0){
                   if(key != 'trifecta'){
                       $('[data-bet="'+key+'"][data-value="'+oldTicket[key].gameBet+'"]').click();
                   } else {
                       oldTrifecta = oldTicket.trifecta.gamePretty;
                       arrTrifecta = oldTrifecta.split('-');
                       $( '[data-bet="trifecta"][data-place="1"][data-number="'+arrTrifecta[0]+'"]').click();
                       $( '[data-bet="trifecta"][data-place="2"][data-number="'+arrTrifecta[1]+'"]').click();
                       $( '[data-bet="trifecta"][data-place="3"][data-number="'+arrTrifecta[2]+'"]').click();
                   }
                   n++;
                }
            }
        }

        if(n > 0){
            $('#betting-amount').val(oldBettingAmount)
        }

    });

    setLangText();
});

function setLangText()
{
    $("[data-langName]").map(function(){
        var langName = $(this).attr('data-langName');
        $(this).text(langArr[language][langName]);
    });
}

function init(odds){
    getDefaults().then(() => {
        var raceData = raceInfo();
        var raceStatus = raceData['Dog6Race'][0]['RaceStatus'];
        var argRaceData = raceData['Dog6Race'][0];
        handleBettingScreen(argRaceData);
        fillQuotesWithRetry(raceData, odds);
        var videoName= raceData['Dog6Race'][0]['Winner']+'-'+ raceData['Dog6Race'][0]['SecondPlace']+'-'+raceData['Dog6Race'][0]['ThirdPlace']
        if(raceStatus == 1){
            createFinishScreen(argRaceData);
            showFinishScreen(argRaceData);
            JackpotWinnerNotice.beginRaceJackpotFlow(argRaceData);
        }
    });
}

function showNavbar() {
    // checks if showLogin response is set to 1
    if (window['showLogin'] == 1) {
        $('.game-nav-bar').css('display', 'flex');
    } else {
        $('.game-nav-bar').css('display', 'none');
    }
}

function getDefaults() {
    return new Promise( (resolve, reject) => {
      $.ajax({
        url: window['API_URL'] + '/luckyballs/game-config/get',
        type: "post",
           data: {  } , // ovde mozes da prosledis podatke
           success: function (response) {
               window['currency'] =  response.Currency;
               $('#currency').text(window['currency']);
               window['menu'] = (response['Online_Menu'] !== undefined && response['Online_Menu'] != '' && response['Online_Menu'] != null) ? response['Online_Menu'] : false;
               if (window['menu'] && !/electron=true/.test(window.location.href)) {
                   $('.terminal-left').show();
                   $("#nav-icon1").show();
                   renderMenu();
               }
              window['showLogin'] =  (response['showLogin'] !== undefined && response['showLogin'] != '' && response['showLogin'] != null) ? response['showLogin'] : 0;
              $('#Dog6_MaxBet').data('value', response.Dog6_MaxBet)
              $('#Dog6_MinBet').data('value', response.Dog6_MinBet)
              $('#betting-amount').val(response.Dog6_MinBet)
              $('#CustomAmount1').text(response.CustomAmount1).data('value', response.CustomAmount1)
              $('#CustomAmount2').text(response.CustomAmount2).data('value', response.CustomAmount2)
              $('#CustomAmount3').text(response.CustomAmount3).data('value', response.CustomAmount3)
              showNavbar();
              // manages any click and login/logout events
              loginManagement(auth, user, navbar, credit);
              
              // Call chat script
              if (window['token'] && !/terminal/.test(window.location.href)) {
                chat(window['token']);
              }

              /**
               * Numpad set
               */
              $('[data-predefined="1"]').text(response['CustomAmount1']).attr('data-value', response['CustomAmount1']);
              $('[data-predefined="2"]').text(response['CustomAmount2']).attr('data-value', response['CustomAmount2']);
              $('[data-predefined="3"]').text(response['CustomAmount3']).attr('data-value', response['CustomAmount3']);
              $('[data-predefined="min"]').attr('data-value', response['Bingo_MinBet']);
              $('[data-predefined="max"]').attr('data-value', response['Bingo_MaxBet']);

              resolve();
          },
          error: function(jqXHR, textStatus, errorThrown) {
              if(debug){
                  alert(errorThrown)
              }
              reject();
          }
      });
    });
}

/**
 * Betting amount - allow only positive numbers and dot.
 */
document.getElementById('betting-amount').onkeydown = (e) => {
    var value =  e.target.value;
    //only allow a-z, A-Z, digits 0-9 and comma, with only 1 consecutive comma ...
    if (!e.key.match(/[0-9.BackSpaceDelete]/) || (e.key == '.' && value[value.length-1] == '.')) {
      e.preventDefault();
    }
}

/**
 * @description API CALLS
 */
/**
 * After buy attempt, restore betting mask from current race phase.
 * Buy shows #mask as a loading overlay; on reject it must not stay like "bets closed".
 */
function restoreBettingMaskAfterBuy() {
    try {
        var raceData = raceInfo();
        if (raceData && raceData['Dog6Race'] && raceData['Dog6Race'][0]) {
            handleGameMask(raceData['Dog6Race'][0]['RaceStatus']);
            return;
        }
    } catch (e) {}
    $('#mask').hide();
}

function buyTicket(ticket, amount) {
    /**
     * Session ID IE TOKEN FOR API.
     */
    let sessionToken = window['customLoggedIn'] && window['customToken'] ?
         window['customToken'] : CookieHelper.get('token') != '' ?
             CookieHelper.get('token') : window['token'];
    $('#mask').show();
    $.ajax({
        url: window['API_URL'] + '/dog-race/ticket/buy',
        type: "post",
           data: { TicketAmount: amount, Items : ticket, SessionID: sessionToken } , 
           success: function (response) {
               if (response.Status == 0) {
                   restoreBettingMaskAfterBuy();
                   $('#modal-title').text(langArr[language].error_purchasing_ticket);
                   $('#gameModal').modal('show');
                   return false;
               } else {
                    if (/electron=true/.test(window.location.href)) {
                        window.parent.postMessage({
                            eventName: 'bought_ticket',
                            ticketData: ticket,
                            responseData: response
                          }, '*'); 
                    }
                    resetTicket();
                    getTickets();
                    var updateCreditEvent = new CustomEvent("get_credit");
                    window.dispatchEvent(updateCreditEvent);
                    restoreBettingMaskAfterBuy();
                    $('#buyTicketModal').modal('show');
                    if ("TicketData" in response) {
                        if ("Dog6Ticket" in response.TicketData) {
                            $('#boughtTicketId').html(" ID " + response.TicketData.Dog6Ticket[0].TicketID);
                        }
                    }
                    setTimeout(function(){
                    $('#buyTicketModal').modal('hide');
                    $('#boughtTicketId').html("");
                    }, 2000);
               }
          },
          error: function(jqXHR, textStatus, errorThrown) {
              restoreBettingMaskAfterBuy();
              if(debug){
                  console.log(errorThrown)
              }
          }
      });
}

/**
 * Checks for jackpot and if exists creates jackpotObj global obj with jackpot details.
 * 
 * @param {*} resp 
 */
const checkForJackpot = async (resp) => {
    if (typeof resp === 'object' && Object.keys(resp).length) {
        if ('RaceJackPotCode' in resp && "Dog6_JackPotValue" in resp) {
            //resp.RaceJackPotCode = 'CCEE' // hardcoded 4 test purposes delete after
            if (resp.RaceJackPotCode) {
                // forming global jackpotObj
                window['jackpotObj'] = {
                    jackpotCode: resp.RaceJackPotCode,
                    jackpotValue: resp.Dog6_JackPotValue
                } 
            }
        }
    }
}

const clearJackpot = () => {
    // Clears jackpotObj
    window['jackpotObj'] = {};
    // Hide main jackpot div
    var informer = document.querySelector('.jackpot-informer');
    if (informer) {
      informer.style.display = 'none';
    }
    // Clears ticket jackpot css if exists
    let tickets = document.querySelectorAll('.ticket-holder');
    if (tickets) {
        if (tickets.length) {
            tickets.forEach(ticket => ticket.classList.contains('dr-jackpot-ticket') ? ticket.classList.remove('dr-jackpot-ticket') : '');
        }
    }
}

/**
 * Shows Jackpot event above video screen.
 * 
 * @param {*} jackPotDetails 
 */
const showJackpotEvent = (jackPotDetails) => {
    // Show jackpot div
    var informer = document.querySelector('.jackpot-informer');
    if (informer) {
      informer.style.display = 'flex';
    }

    // Set JACKPOT VALUE AND CODE
    document.getElementById('lbJackpotValue').innerHTML = jackPotDetails.jackpotValue;
    document.getElementById('lbJackpotCode').innerHTML = jackPotDetails.jackpotCode;
}

const handleJackpot = (jackPotDetails) => {
    if (typeof jackPotDetails === 'object' && Object.keys(jackPotDetails).length) {
        // IF RACE IS RUNNING CHECK FOR JACKPOT AND IF UPDATE TICKETS
        if (Number(jackPotDetails.RaceStatus) === 1) {
            checkForJackpot(jackPotDetails);
        } else {
            clearJackpot();
        }
    }
}

// Listen for the showJackpotEvent event.
window.addEventListener('showJackpotEvent', function (data) {
    showJackpotEvent(data.detail);
}, false);

// Get tickets for current game
function getTickets(){
    $.ajax({
        url: window['API_URL'] + '/dog-race/ticket/get',
        type: "post",
           data: {SessionID: CookieHelper.get('token') != '' ? CookieHelper.get('token') : window['token']} ,
           success: function (response) {
               drawTickets(response)
           },
           error: function(jqXHR, textStatus, errorThrown) {
               if(debug){
                   console.log(jqXHR.responseText)
               }
           }
       });
}

function raceInfo(){
    var tmp = null;
    $.ajax({
        'async': false,
        'type': "POST",
        'global': false,
        'dataType': 'json',
        url: window['API_URL']  + '/dog-race/game/get',
        'data': {},
        'success': function (data) {
            $('#roundNr').text(data['Dog6Race'][0]['ID_Today']);
            window['currentRaceRound'] = data['Dog6Race'][0]['ID_Today'];
            $('#jackpot').text(data['Dog6Race'][0]['Dog6_JackPotValue']);
            tmp = data;
        }
    });
    handleJackpot(tmp['Dog6Race'][0]);
    return tmp;
}

function invalidateTrifectaOdds() {
    ticket.trifecta.gameBet = 0;
    ticket.trifecta.gamePretty = '';
    $('#trifecta-odd').val('');
}

function isTrifectaComplete() {
    return trifecta.first > 0
        && trifecta.second > 0
        && trifecta.third > 0
        && String(trifecta.first) !== String(trifecta.second)
        && String(trifecta.first) !== String(trifecta.third)
        && String(trifecta.second) !== String(trifecta.third);
}

function getSelectedTrifectaCount() {
    return $('#trifecta-table').find('.betting-dogs-btn-red').length;
}

function validateTrifectaBeforeBuy() {
    var selectedCount = getSelectedTrifectaCount();

    // Partial UI selection must never go on a ticket
    if (selectedCount > 0 && selectedCount < 3) {
        invalidateTrifectaOdds();
        return false;
    }

    // All three selected but odds/id not ready yet
    if (selectedCount === 3 && (!ticket.trifecta.gameBet || ticket.trifecta.gameBet == 0 || !isTrifectaComplete())) {
        invalidateTrifectaOdds();
        return false;
    }

    // Stale ticket data without UI selection
    if (selectedCount === 0 && ticket.trifecta.gameBet != 0) {
        invalidateTrifectaOdds();
    }

    if (selectedCount === 3 && ticket.trifecta.gamePretty) {
        var expected = trifecta.first + '-' + trifecta.second + '-' + trifecta.third;
        if (String(ticket.trifecta.gamePretty) !== String(expected)) {
            invalidateTrifectaOdds();
            return false;
        }
    }

    return true;
}

function handleTrifectaBet(_this, bet, trifectaPlace, trifectaNumber){

    $('*[data-bet="'+bet+'"][data-place="'+trifectaPlace+'"]').removeClass('betting-dogs-btn-red');
    _this.addClass('betting-dogs-btn-red').removeClass('betting-dogs-btn-grey');

    $('*[data-bet="'+bet+'"][data-number="'+trifectaNumber+'"]').not(_this).addClass('betting-dogs-btn-grey');
    // find selected dogs
    var selectedPlaces = $( "#trifecta-table" ).find( ".betting-dogs-btn-red" );

    var selectedArr = []
    $.each(selectedPlaces, function(index, item) {
        selectedArr.push($(item).data('number'))
    });

    var disabledPlaces = $( "#trifecta-table" ).find( ".betting-dogs-btn-grey" );

    $.each(disabledPlaces, function(index, item) {
        if(!isInArray($(item).data('number'), selectedArr)){
            $(item).removeClass('betting-dogs-btn-grey')
        }
    });

    if(trifectaPlace == 1){
        trifecta.first = trifectaNumber;
    }
    if(trifectaPlace == 2){
        trifecta.second = trifectaNumber
    }
    if(trifectaPlace == 3){
        trifecta.third = trifectaNumber
    }

    // Always drop previous odd/id until a full valid 1-2-3 selection is confirmed
    invalidateTrifectaOdds();

    if(isTrifectaComplete()){

        var trifectaGame = trifecta.first +'-'+ trifecta.second +'-'+ trifecta.third;

        $.ajax({
           url: window['API_URL'] + '/dog-race/game/get-trifecta',
           type: "post",
           data: {trifecta : trifectaGame} ,
           success: function (response) {
               // Ignore late responses if selection changed meanwhile
               var currentGame = trifecta.first +'-'+ trifecta.second +'-'+ trifecta.third;
               if (!isTrifectaComplete() || currentGame !== trifectaGame) {
                   return;
               }
               $('#trifecta-odd').val(response.odd);
               ticket['trifecta'].gameBet = response.trifectaId;
               ticket['trifecta'].gamePretty = trifectaGame;
           },
           error: function(jqXHR, textStatus, errorThrown) {
               invalidateTrifectaOdds();
               if(debug){
                   console.log(errorThrown)
               }
            }
       });
    }
}

// Draw tickets
function getTicketRoundNo(ticketData) {
    if (ticketData.TodayRaceID != null && ticketData.TodayRaceID !== '') {
        return ticketData.TodayRaceID;
    }

    if (typeof window['currentRaceRound'] !== 'undefined' && window['currentRaceRound'] != null && window['currentRaceRound'] !== '') {
        return window['currentRaceRound'];
    }

    return '';
}

function drawTickets(data){
    if(data.Data.length == 0) {
        $('#ticketsScroll').html('');
        $('#ticketsScroll').html('<div class="no-tickets-message">'+langArr[language].no_tickets_for_current_game+'</div>')
    } else {

        var detSmallInterval = 1;
        if (typeof window['currency'] != "string") {
            detSmallInterval = 250;
        }

      setTimeout( () => {
        $('#ticketsScroll').html('');

        data.Data.sort(function(a,b){
            return b.TicketTime<a.TicketTime; 
        })

        for (var i = data.Data.length - 1; i >= 0; i--) {

            if ('ticket' in data.Data[i]) {

                // SET JACKPOT BLOCK
                var jackpotTicketClass = '';
                // IF GLOBAL JACKPOT OBJECT EXISTS (FROM GET GAME RESP)
                if (typeof window['jackpotObj'] === 'object' && Object.keys(window['jackpotObj']).length) {
                    // IF GLOBAL JACKPOT CODE IS SAME AS JACKPOT CODE ON THE TICKET FIRE EVENT TO SHOW JACKPOT AND SET TICKET CSS CLASS FOR FLASHING WINNING TICKET
                    if (data.Data[i].JPCode && window['jackpotObj'].jackpotCode) {
                        if (String(data.Data[i].JPCode) ===  String(window['jackpotObj'].jackpotCode)) {
                            const showJackpotEvent = new CustomEvent('showJackpotEvent', { detail: window['jackpotObj']});
                            window.dispatchEvent(showJackpotEvent);
                            jackpotTicketClass = 'dr-jackpot-ticket';
                        } 
                    }
                }

                var winer = data.Data[i].ticket.hasOwnProperty('winner')  ? data.Data[i].ticket.winner.odd : '';
                var winerClass = winer == '' ? '' : 'highlightTicket';
                var winerBox = winer == '' ? '' : dogClass[winer];

                var place = data.Data[i].ticket.hasOwnProperty('place') ? data.Data[i].ticket.place.odd : '';
                var placeClass = place == '' ? '' : 'highlightTicket';
                var placeBox = place == '' ? '' : dogClass[place];

                var show  = data.Data[i].ticket.hasOwnProperty('show')  ? data.Data[i].ticket.show.odd : '';
                var showClass = show == '' ? '' : 'highlightTicket';
                var showBox = show == '' ? '' : dogClass[show];

                var low_high  = data.Data[i].ticket.hasOwnProperty('low_high')  ? data.Data[i].ticket.low_high.odd : '';
                var low_highClass = low_high == '' ? '' : 'highlightTicket';
                var lowClass = low_high == 1 ? 'highlightTicket' : '';
                var highClass = low_high == 2 ? 'highlightTicket' : '';
                var low_highLowOddValue = low_high == 1 ?  data.Data[i].ticket.low_high.OddValue : '';
                var low_highHighOddValue = low_high == 2 ?  data.Data[i].ticket.low_high.OddValue : '';
    
                var odd_even  = data.Data[i].ticket.hasOwnProperty('odd_even')  ? data.Data[i].ticket.odd_even.odd : '';
                var odd_evenClass = odd_even == '' ? '' : 'highlightTicket';
                var oddClass = odd_even == 2 ? 'highlightTicket' : '';
                var evenClass = odd_even == 1 ? 'highlightTicket' : '';
                var odd_evenOddOddValue = odd_even == 2 ?  data.Data[i].ticket.odd_even.OddValue : '';
                var odd_evenEvenOddValue = odd_even == 1 ?  data.Data[i].ticket.odd_even.OddValue : '';
    
                var sum12  = data.Data[i].ticket.hasOwnProperty('sum12')  ? data.Data[i].ticket.sum12.odd : '';
                var sum12Class = sum12 == '' ? '' : 'highlightTicket';
                var sum12minusClass = sum12 == 1 ? 'highlightTicket' : '';
                var sum12plusClass = sum12 == 2 ? 'highlightTicket' : '';
                var sum12minusOddValue = sum12 == 1 ?  data.Data[i].ticket.sum12.OddValue : '';
                var sum12plusOddValue = sum12 == 2 ?  data.Data[i].ticket.sum12.OddValue : '';
    
                var sum123  = data.Data[i].ticket.hasOwnProperty('sum123')  ? data.Data[i].ticket.sum123.odd : '';
                var sum123Class = sum123 == '' ? '' : 'highlightTicket';
                var sum123minusClass = sum123 == 1 ? 'highlightTicket' : '';
                var sum123plusClass = sum123 == 2 ? 'highlightTicket' : '';
                var sum123minusOddValue = sum123 == 1 ?  data.Data[i].ticket.sum123.OddValue : '';
                var sum123plusOddValue = sum123 == 2 ?  data.Data[i].ticket.sum123.OddValue : '';
    
                var double_chance  = data.Data[i].ticket.hasOwnProperty('double_chance')  ? data.Data[i].ticket.double_chance.odd : '';
                var double_chanceClass = double_chance == '' ? '' : 'highlightTicket';
                var double_chanceFirst = '';
                var double_chanceSecond = '';
                var double_chanceFirstClass = '';
                var double_chanceSecondClass = '';
                var double_chanceOddValue = '';
                var double_chancePlay = 0;
                if(double_chance != ''){
                    double_chanceFirst = data.Data[i].ticket.double_chance.Description.charAt(3);
                    double_chanceSecond = data.Data[i].ticket.double_chance.Description.charAt(4);
                    double_chanceFirstClass = dogClass[double_chanceFirst];
                    double_chanceSecondClass = dogClass[double_chanceSecond];
                    double_chanceOddValue = data.Data[i].ticket.double_chance.OddValue;
                    double_chancePlay = double_chanceFirst+'-'+double_chanceSecond;
                }

                // Trifecta
                var trifecta  = data.Data[i].ticket.hasOwnProperty('trifecta')  ? data.Data[i].ticket.trifecta.odd : '';
                var trifectaClass = trifecta == '' ? '' : 'highlightTicket';
                var trifectaFirst = '';
                var trifectaSecond = '';
                var trifectaThird = '';
                var trifectaFirstClass = '';
                var trifectaSecondClass = '';
                var trifectaThirdClass = '';
                var trifectaOddValue = '';
                var trifectaPlay = 0;
                if(trifecta != ''){
                    trifectaFirst = data.Data[i].ticket.trifecta.Description.split("-")[0];
                    trifectaSecond = data.Data[i].ticket.trifecta.Description.split("-")[1];
                    trifectaThird = data.Data[i].ticket.trifecta.Description.split("-")[2];
                    trifectaFirstClass = dogClass[trifectaFirst];
                    trifectaSecondClass = dogClass[trifectaSecond];
                    trifectaThirdClass = dogClass[trifectaThird];
                    trifectaOddValue = data.Data[i].ticket.trifecta.OddValue;
                    trifectaPlay = trifectaFirst+'-'+trifectaSecond+'-'+trifectaThird;
                }

                // Perfecta
                var perfecta  = data.Data[i].ticket.hasOwnProperty('perfecta')  ? data.Data[i].ticket.perfecta.odd : '';
                var perfectaClass = perfecta == '' ? '' : 'highlightTicket';
                var perfectaFirst = '';
                var perfectaSecond = '';
                var perfectaFirstClass = '';
                var perfectaSecondClass = '';
                var perfectaOddValue = '';
                var perfectaPlay = 0;
                if(perfecta != ''){
                    perfectaFirst = data.Data[i].ticket.perfecta.Description.split("-")[0];
                    perfectaSecond = data.Data[i].ticket.perfecta.Description.split("-")[1];
                    perfectaFirstClass = dogClass[perfectaFirst];
                    perfectaSecondClass = dogClass[perfectaSecond];
                    perfectaOddValue = data.Data[i].ticket.perfecta.OddValue;
                    perfectaPlay = perfectaFirst+'-'+perfectaSecond;
                }

                var ticketRoundNo = getTicketRoundNo(data.Data[i]);
                var ticketRoundHtml = ticketRoundNo !== ''
                    ? '<div class="ticket-bar-round">' + langArr[language].round_no + ': ' + ticketRoundNo + '</div>'
                    : '';

                $('#ticketsScroll').append('<div class="ticket-holder ' + jackpotTicketClass + '" id="ticket_holder_'+data.Data[i].TicketID+'"></div>');
                $('#ticket_holder_'+data.Data[i].TicketID).append(
                    '<div class="ticket-bar clearfix dog-racing-ticket-bar">' +
                        '<div class="ticket-bar-left">' +
                            '<div class="ticket-bar-id">' + langArr[language].ticket_id + ': ' + data.Data[i].TicketID + '</div>' +
                            ticketRoundHtml +
                        '</div>' +
                        '<div class="ticket-bar-right">' + data.Data[i].TicketAmount + ' ' + window['currency'] + '</div>' +
                    '</div>' +
                    '<div class="ticket-content dog-racing-ticket-content" id="ticket_content_'+data.Data[i].TicketID+'"></div>'
                );
                $('#ticket_content_'+data.Data[i].TicketID).append('<div class="ticket-dogs-statistic"><div class="tds-holder '+winerClass+'" id="winner_'+data.Data[i].TicketID+'"><span class="'+winerClass+'">'+langArr[language].winner+'</span><input class="tds-input '+winerBox+'" type="text" readonly value="'+winer+'" /></div><div class="tds-holder '+placeClass+'" id="place_'+data.Data[i].TicketID+'"><span class="'+placeClass+'">'+langArr[language].place+'</span><input class="tds-input '+placeBox+'" type="text" readonly value="'+place+'" /></div><div class="tds-holder"><span class="'+showClass+'" id="show_'+data.Data[i].TicketID+'">'+langArr[language].show+'</span><input class="tds-input '+showBox+'" type="text" readonly value="'+show+'" /></div></div>');
                $('#ticket_content_'+data.Data[i].TicketID).append('<div class="ticket-dogs-title" id="perfectaTitle_'+data.Data[i].TicketID+'" data-play="'+perfectaPlay+'" >'+langArr[language].perfecta+'</div><div class="ticket-dogs-statistic" id="perfecta_'+data.Data[i].TicketID+'"><div class="tds-holder"><input class="tds-input tds-input-fullwidth" type="text" readonly value="'+perfectaOddValue+'"/></div><div class="tds-holder"><span class="tds-holder-dark '+perfectaClass+'">'+langArr[language].winner+'</span><input class="tds-input '+perfectaFirstClass+'" readonly value="'+perfectaFirst+'" type="text"/></div><div class="tds-holder"><span class="tds-holder-dark '+perfectaClass+'">'+langArr[language].second+'</span><input class="tds-input '+perfectaSecondClass+'" readonly value="'+perfectaSecond+'" type="text"/></div></div>')
                $('#ticket_content_'+data.Data[i].TicketID).append('<div class="ticket-dogs-statistic dog-racing-combo-row"><div class="dog-racing-combo-block"><div class="ticket-dogs-title" id="trifectaTitle_'+data.Data[i].TicketID+'" data-play="'+trifectaPlay+'">'+langArr[language].trifecta+'</div><input class="tds-input" readonly value="'+trifectaOddValue+'" type="text"/><input class="tds-input '+trifectaFirstClass+'" readonly value="'+trifectaFirst+'" type="text"/><input class="tds-input '+trifectaSecondClass+'" readonly value="'+trifectaSecond+'" type="text"/><input class="tds-input '+trifectaThirdClass+'" readonly value="'+trifectaThird+'" type="text"/></div><div class="dog-racing-combo-block"><div class="ticket-dogs-title '+double_chanceClass+'" id="doubleChanceTitle_'+data.Data[i].TicketID+'" data-play="'+double_chancePlay+'">'+langArr[language].double_chance+'</div><input class="tds-input tds-input-fullwidth" value="'+double_chanceOddValue+'" readonly type="text"/><input class="tds-input '+double_chanceFirstClass+'" value="'+double_chanceFirst+'" readonly type="text"/><input class="tds-input '+double_chanceSecondClass+'" readonly value="'+double_chanceSecond+'" type="text"/></div></div>')
                $('#ticket_content_'+data.Data[i].TicketID).append('<div class="ticket-dogs-title" id="lowHighTitle_'+data.Data[i].TicketID+'">'+langArr[language].low+' / '+langArr[language].high+'</div><div class="ticket-dogs-statistic"><div class="ticket-dogs-left '+lowClass+'" data-ticketbet="low">1, 2, 3 / '+low_highLowOddValue+'</div><div class="ticket-dogs-right '+highClass+'" data-ticketbet="high">4, 5, 6 / '+low_highHighOddValue+'</div></div>')
                $('#ticket_content_'+data.Data[i].TicketID).append(' <div class="ticket-dogs-title" id="oddEvenTitle_'+data.Data[i].TicketID+'">'+langArr[language].even+' / '+langArr[language].odd+'</div><div class="ticket-dogs-statistic"><div class="ticket-dogs-left '+evenClass+'" data-ticketbet="even">'+langArr[language].even+' / '+odd_evenEvenOddValue+'</div><div class="ticket-dogs-right '+oddClass+'" data-ticketbet="odd">'+langArr[language].odd+' / '+odd_evenOddOddValue+'</div></div>')
                $('#ticket_content_'+data.Data[i].TicketID).append('<div class="ticket-dogs-title" id="sum123Title_'+data.Data[i].TicketID+'">'+langArr[language].sum+' 1+2+3</div><div class="ticket-dogs-statistic"><div class="ticket-dogs-left '+sum123minusClass+'" data-ticketbet="minus">'+langArr[language].less+' 10.5 / '+sum123minusOddValue+' </div><div class="ticket-dogs-right '+sum123plusClass+'" data-ticketbet="plus">'+langArr[language].more+' 10.5 / '+sum123plusOddValue+' </div></div>')
                $('#ticket_content_'+data.Data[i].TicketID).append(' <div class="ticket-dogs-title" id="sum12Title_'+data.Data[i].TicketID+'">'+langArr[language].sum+' 1+2</div><div class="ticket-dogs-statistic"><div class="ticket-dogs-left '+sum12minusClass+'" data-ticketbet="minus">'+langArr[language].less+' 7.5 / '+sum12minusOddValue+'</div><div class="ticket-dogs-right '+sum12plusClass+'" data-ticketbet="plus">'+langArr[language].more+' 7.5 / '+sum12plusOddValue+'</div></div>')
                $('#ticket_content_'+data.Data[i].TicketID).append(' <div class="jackpot-code jackpot-dogs-code"><span class="tsh-cr-down-red">'+langArr[language].jackpot_code+': '+data.Data[i].JPCode +'</span></div>')
            } else {
                console.error('no ticket in resp')
            }

        }

      } , detSmallInterval)

        var drawTicketsEvent = new CustomEvent("onTicketReady", {detail: null});
        setTimeout(() => {
            dispatchEvent(drawTicketsEvent);
        }, 100);

    }

}
function resetTicket(){
    ticket = {
        winner : {
            gameId : '01',
            gameBet : 0
        } , 
        place : {
            gameId : '05',
            gameBet : 0
        }, 
        show : {
            gameId : '06',
            gameBet : 0
        }, 
        trifecta : {
            gameId : '19',
            gameBet : 0,
            gamePretty : ''
        }, 
        perfecta : {
            gameId : '04',
            gameBet : 0
        }, 
        double_chance : {
            gameId : '07',
            gameBet : 0
        }, 
        low_high : {
            gameId : '14',
            gameBet : 0
        },
        odd_even : {
            gameId : '15',
            gameBet : 0
        }, 
        sum123 : {
            gameId : '17',
            gameBet : 0
        }, 
        sum12 : {
            gameId : '16',
            gameBet : 0
        }
    }

    trifecta.first = 0;
    trifecta.second = 0;
    trifecta.third = 0;
    $('#trifecta-odd').val('');
    $('.select-bet').removeClass('betting-dogs-btn-red').removeClass('betting-dogs-btn-grey');
}

function fillQuotes(quotes, odds){
    var obj = $.extend({}, quotes['Dog6Race'][0]);
    var obj2 = quotes['Dog6Race'][0];
    $.each(odds, function(index, item) {
        $('#'+item).text(obj2[item])
    }, obj);
}

/** True when betting-phase odds look populated (server sometimes returns all 0 briefly). */
function hasValidBettingOdds(raceData) {
    if (!raceData || !raceData['Dog6Race'] || !raceData['Dog6Race'][0]) {
        return false;
    }
    var q = raceData['Dog6Race'][0];
    return Number(q.WinOdd1) > 0
        && Number(q.WinOdd2) > 0
        && Number(q.WinOdd3) > 0;
}

/**
 * Fill odds; if RaceStatus=0 but values are still 0, retry game/get a few times.
 */
function fillQuotesWithRetry(raceData, oddsList, attempt) {
    attempt = attempt || 0;
    if (!raceData || !raceData['Dog6Race'] || !raceData['Dog6Race'][0]) {
        return;
    }
    fillQuotes(raceData, oddsList);

    var status = Number(raceData['Dog6Race'][0]['RaceStatus']);
    if (status !== 0 || hasValidBettingOdds(raceData) || attempt >= 10) {
        return;
    }

    setTimeout(function() {
        fillQuotesWithRetry(raceInfo(), oddsList, attempt + 1);
    }, 1500);
}

function handleBettingScreen(arg){
    var nextTimer = arg.RaceStatus == 0 ? arg.RaceTime : arg.RaceTimerResult;
    handleGameMask(arg.RaceStatus);
    $('.dog-racing-video-player').hide();
    $('.dog-racing-video-holder').show();
    if(arg.raceStatus == 0) {
        waitRace(nextTimer);
    }else{
        waitRaceFinish(arg);
    }
}

function handleGameMask(raceStatus){
    if(raceStatus == 0){
        $('#mask').hide()
    }else{
        $('#mask').show()
    }
}

function waitRace(raceTime){
    raceTime +=6;
    var raceTimer;
    clearInterval(raceTimer);
    raceTimer = setInterval(function(){

        var newTime = --raceTime;
        $('#fancyTime').text(fancyTimeFormat(newTime));
        loaderPercentage(120, newTime);
        if(raceTime <= 0){
            clearInterval(raceTimer);
            startRace(0);
        }

    },1000);
}

function waitRaceFinish(arg) {
    var raceTimerResult = arg.RaceTimerResult
    raceTimerResult +=1;
    var raceTimer;
    clearInterval(raceTimer);
    raceTimer = setInterval(() => {
        var newTime = --raceTimerResult;
       $('#fancyTime').text(fancyTimeFormat(newTime));
       loaderPercentage(70, newTime);
       if(raceTimerResult <= 0){
           var updateCreditEvent = new CustomEvent("get_credit");
           window.dispatchEvent(updateCreditEvent);
           clearInterval(raceTimer);
           openBets();
       }
   },1000);
}

function startRace(attempt){
    attempt++;
    var raceData = raceInfo();

    handleGameMask(1);
    $('#video-main').addClass('waiting');
    $('.dog-racing-video-player').show();
    $('.dog-racing-video-holder').hide();

    if(raceData['Dog6Race'][0]['RaceStatus'] == 2 ){
        console.log('No race data');
        setTimeout(function(){
            startRace(attempt);
        }, 4000);
        return false;
    }

    if(raceData['Dog6Race'][0]['RaceStatus'] == 0 ){
        init(odds);
        return false;
    }

    if(attempt == 5){
        location.reload();
        return false;
    }

    if(raceData['Dog6Race'][0]['Winner'] == null) {
         setTimeout(function(){
            startRace(attempt);
            
        }, 3000);
        return false;
    }

    var argRaceData = raceData['Dog6Race'][0];

    JackpotWinnerNotice.beginRaceJackpotFlow(argRaceData, function() {
        playRaceVideo(argRaceData);
    });
}

function playRaceVideo(argRaceData) {
    var videoFile = argRaceData['Winner']+'-'+ argRaceData['SecondPlace']+'-'+argRaceData['ThirdPlace'];

        var video = $("#video-holder video")[0];
        video.src = videoUrl+videoFile+'.mp4';

        video.load();

        createFinishScreen(argRaceData);

        waitRaceFinish(argRaceData);

        video.addEventListener('loadedmetadata',  function playVideo() {
            var timer1;
            var duration = video.duration.toString();
            var x = duration.split(".")[0];
            var videoTime = parseInt(x) * 1000;
            //iOS
            if (checkIos < 10) {
                $('#video-holder').append('<div class="dog-raciog-ios-less"><div class="apple-inner">'+langArr[language].apple_video_no_support+'</div></div>')
            }else{
                video.play();
            }

            timer1 = setTimeout(function(){ 
                if (checkIos < 10) {
                    $('.dog-raciog-ios-less').remove();
                }else{ 
                    video.pause();
                    video.src = '';
                }
                showFinishScreen(argRaceData);
            }, videoTime);

            video.removeEventListener('loadedmetadata', playVideo , false);
        });

}

function showTicketsResult(data){

    var first = data.Winner;
    var second = data.SecondPlace;
    var third = data.ThirdPlace;

    var perfecta = first+'-'+second;
    var trifecta = first+'-'+second+'-'+third;

    var tickets = $(".ticket-holder").map(function () {
       var ticketId = $(this).attr('id').split('_')[2];
       // Highlight winner
       if($('#winner_'+ticketId).hasClass('highlightTicket') ){
           var _thisWinner = $('#winner_'+ticketId)
           if($('.tds-input', _thisWinner).val() == first){
               $('#winner_'+ticketId).addClass('successBet')
               $('#ticket_holder_' + ticketId).addClass('winning-ticket')
           }
       }

       // Highlight second
       if($('#place_'+ticketId).hasClass('highlightTicket')){
           var _thisPlace = $('#place_'+ticketId)
           if($('.tds-input', _thisPlace).val() == first || $('.tds-input', _thisPlace).val() == second){
               $('#place_'+ticketId).addClass('successBet')
               $('#ticket_holder_' + ticketId).addClass('winning-ticket')
           }
       }

       // Highlight third
       if($('#show_'+ticketId).hasClass('highlightTicket')){
           var _thisShow = $('#show_'+ticketId).parent()
           if($('.tds-input', _thisShow).val() == first || $('.tds-input', _thisShow).val() == second || $('.tds-input', _thisShow).val() == third ){
               $('#show_'+ticketId).addClass('successBet')
               $('#ticket_holder_' + ticketId).addClass('winning-ticket')
           }
       }

       // Highlight perfecta
       if($('#perfectaTitle_'+ticketId).data('play') != '0'){
           if($('#perfectaTitle_'+ticketId).data('play') == perfecta){
               $('#perfectaTitle_'+ticketId).addClass('successBet')
               $('#ticket_holder_' + ticketId).addClass('winning-ticket')
           }
       }

       // Highlight trifecta
       if($('#trifectaTitle_'+ticketId).data('play') != '0'){
           if($('#trifectaTitle_'+ticketId).data('play') == trifecta){
               $('#trifectaTitle_'+ticketId).addClass('successBet')
               $('#ticket_holder_' + ticketId).addClass('winning-ticket')
           }
       }

       // Highlight trifecta
       if($('#doubleChanceTitle_'+ticketId).data('play') != '0'){
           var doubleChancePlay = $('#doubleChanceTitle_'+ticketId).data('play');
           var doubleChancecCombination1 = second+'-'+first;
           var doubleChancecCombination2 = first+'-'+second;
           if($('#doubleChanceTitle_'+ticketId).data('play') == doubleChancecCombination1 || $('#doubleChanceTitle_'+ticketId).data('play') == doubleChancecCombination2){
               $('#doubleChanceTitle_'+ticketId).addClass('successBet')
               $('#ticket_holder_' + ticketId).addClass('winning-ticket')
           }
       }

       // Low/ high highlight
       var _thisLowHigh = $('#lowHighTitle_'+ticketId).next();
       var lowHighPlayed = $('.highlightTicket', _thisLowHigh).data('ticketbet');
       // Highlight low high
       if(lowHighPlayed == 'low' || lowHighPlayed == 'high'){
           if(lowHighPlayed == 'low'){
               if(first == 1 || first == 2 || first == 3){
                   $('.highlightTicket', _thisLowHigh).addClass('successBet')
                   $('#ticket_holder_' + ticketId).addClass('winning-ticket')
               }
           }
           if(lowHighPlayed == 'high'){
               if(first == 4 || first == 5 || first == 6){
                   $('.highlightTicket', _thisLowHigh).addClass('successBet')
                   $('#ticket_holder_' + ticketId).addClass('winning-ticket')
               }
           }
       }

        // Odd / Even highlight
       var _thisOddEven = $('#oddEvenTitle_'+ticketId).next();
       var oddEvenPlayed = $('.highlightTicket', _thisOddEven).data('ticketbet');

       if(oddEvenPlayed == 'odd' || oddEvenPlayed == 'even'){
           if(oddEvenPlayed == 'odd'){
               if(first == 1 || first == 3 || first == 5){
                   $('.highlightTicket', _thisOddEven).addClass('successBet')
                   $('#ticket_holder_' + ticketId).addClass('winning-ticket')
               }
           }
           if(oddEvenPlayed == 'even'){
               if(first == 2 || first == 4 || first == 6){
                   $('.highlightTicket', _thisOddEven).addClass('successBet')
                   $('#ticket_holder_' + ticketId).addClass('winning-ticket')
               }
           }
       }

       // Sum 123 highlight
       var _thisSum123 = $('#sum123Title_'+ticketId).next();
       var sum123Played = $('.highlightTicket', _thisSum123).data('ticketbet');
       var sum123 = first + second + third;
       if(sum123Played == 'minus' || sum123Played == 'plus'){
           if(sum123Played == 'minus'){
               if(sum123 < 10.5){
                   $('.highlightTicket', _thisSum123).addClass('successBet')
                   $('#ticket_holder_' + ticketId).addClass('winning-ticket')
               }
           }
           if(sum123Played == 'plus'){
               if(sum123 > 10.5){
                   $('.highlightTicket', _thisSum123).addClass('successBet')
                   $('#ticket_holder_' + ticketId).addClass('winning-ticket')
               }
           }
       }

       // Sum 12 highlight
       var _thisSum12 = $('#sum12Title_'+ticketId).next();
       var sum12Played = $('.highlightTicket', _thisSum12).data('ticketbet');
       var sum12 = first + second;

       if(sum12Played == 'minus' || sum12Played == 'plus'){
           if(sum12Played == 'minus'){
               if(sum12 < 7.5){
                   $('.highlightTicket', _thisSum12).addClass('successBet')
                   $('#ticket_holder_' + ticketId).addClass('winning-ticket')
               }
           }
           if(sum12Played == 'plus'){
               if(sum12 > 7.5){
                   $('.highlightTicket', _thisSum12).addClass('successBet')
                   $('#ticket_holder_' + ticketId).addClass('winning-ticket')
               }
           }
       }

   });

}

function openBets(){

    $('#video-main').removeClass('waiting');
    var raceData = raceInfo();
    var video = $("#video-holder video")[0];
    video.pause();
    video.src = '';
    fillQuotesWithRetry(raceData, odds);
    waitRace(raceData['Dog6Race'][0]['RaceTimer'])
    showFinishScreen();
    handleGameMask(0);
    getTickets();
}

function showFinishScreen(raceData){
    $('#video-main').removeClass('waiting');
    $('#video-holder').hide();
    $('#finish-screen').show();

    if (typeof raceData != 'undefined') {
        function showTicketsResultEvent() {
            while (typeof window['currency'] != "string") {
                console.log("...")
            }
            if (raceData.Winner == null && raceData.RaceTimer == 0 && raceData.RaceTimerResult > 0) {
                setTimeout(() => {
                    init(odds);
                    getTickets();
                } , 1000)
                removeEventListener("onTicketReady", showTicketsResultEvent);
                return;
            }
            showTicketsResult(raceData)
            removeEventListener("onTicketReady", showTicketsResultEvent);
        }
        addEventListener("onTicketReady", showTicketsResultEvent);
        showTicketsResult(raceData);
    }

}

function createFinishScreen(arg) {
    var name = arg.ID_Today,
        first = arg.Winner,
        second = arg.SecondPlace,
        third = arg.ThirdPlace,
        raceDate = arg.RaceLocalTimeEnd || arg.RaceTimeEnd;

    $('#finish-screen').html('');
    $('#finish-screen').append('<div class="video-round">' + langArr[language].race +  ' : <span>'+name+'</span></div>');
    $('#finish-screen').append('<div class="video-date">'+formatDate(new Date(raceDate))+'</div>');
    $('#finish-screen').append('<div class="video-blue-line"></div>');
    $('#finish-screen').append('<div class="video-dog-place"><div class="dog-square-place"><div class="dog-square '+dogClass[first]+'">'+first+'</div></div><img class="dog-place" src="./img/first-dog.png""/><div class="dog-position-place">'+langArr[language].winner+'</div></div>');
    $('#finish-screen').append('<div class="video-dog-place"><div class="dog-square-place"><div class="dog-square '+dogClass[second]+'">'+second+'</div></div><img class="dog-place" src="./img/second-dog.png""/><div class="dog-position-place">'+langArr[language].second+'</div></div>');
    $('#finish-screen').append('<div class="video-dog-place"><div class="dog-square-place"><div class="dog-square '+dogClass[third]+'">'+third+'</div></div><img class="dog-place" src="./img/third-dog.png""/><div class="dog-position-place">'+langArr[language].third+'</div></div>');
    $('#finish-screen').append('<div class="video-blue-line"></div>');
    $('#finish-screen').append('<div class="video-round with-jackpot-code">' + langArr[language].jackpot_code + ' : <span>' + (arg.RaceJackPotCode || '') + '</span></div>');
}

function showWaitingEmptyScreen(){
    $('#video-main').addClass('waiting');
}

function loaderPercentage(maxNum, newNum){
    var percentage = newNum/maxNum*100;
    // To prevent reported widths more than 100%
    let safePercentage = Number(percentage) > 100 ? String(100) : String(percentage);
    $('.vdh-progress-bar').css({'width' : safePercentage+'%'})
}

// Sys Functions
function fancyTimeFormat(time)
{
    // Hours, minutes and seconds
    var hrs = ~~(time / 3600);
    var mins = ~~((time % 3600) / 60);
    var secs = time % 60;

    // Output like "1:01" or "4:03:59" or "123:03:59"
    var ret = "";

    if (hrs > 0) {
        ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
    }

    ret += "0" + mins + ":" + (secs < 10 ? "0" : "");
    ret += "" + secs;
    return ret;
}

function pad(num, size) {
    var s = num+"";
    while (s.length < size) s = "0" + s;
    return s;
}

function isInArray(value, array) {
    return array.indexOf(value) > -1;
}
function formatDate(date) {
  var hours = date.getHours();
  hours = ("0" + hours).slice(-2)
  var minutes = date.getMinutes();
  minutes = ("0" + minutes).slice(-2);
  var strTime = hours + ':' + minutes;
  return date.getDate() + "." + parseInt(date.getMonth() + 1) + "." + date.getFullYear() + "  " + strTime;
}

function iOSversion() {
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
        // supports iOS 2.0 and later: <https://bit.ly/TJjs1V>
        var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
        return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/games/dog-racing/js/dograce.js
// module id = 1945
// module chunks = 7